import {
    kDevServerProxyPath,
    kLocalServerUrl,
    kProductionServerUrl,
} from "@/shared/urls-and-ports";

import { getUseProductionServer } from "@/client/utils/getUseProductionServer";

const useProductionServer = getUseProductionServer();
const isDev = import.meta.env.DEV;

export const kServerUrl = ((): string => {
    if (useProductionServer) {
        if (isDev) {
            return kDevServerProxyPath;
        }
        return kProductionServerUrl;
    }
    return kLocalServerUrl;
})();
